// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { pastePlugin } from '@atlaskit/editor-plugin-paste';
export type {
	PastePlugin,
	PastePluginOptions,
	PastePluginState,
	LastContentPasted,
} from '@atlaskit/editor-plugin-paste';
